import { memo } from "react";
import styled from "styled-components";

interface Feature {
  title: string;
  description: string;
  icon: string;
}

interface DetailComponentProps {
  feature?: Feature;
  isLast?: boolean;
  index?: number;
}

const DetailComponent = memo(
  ({
    feature = {
      title: "Default Title",
      description: "Default Description",
      icon: "default-icon.png"
    },
    isLast = false,
    index = 0
  }: DetailComponentProps) => {
    return (
      <ResponsiveContainer key={index}>
        <SubFeatureCard>
          <SubFeatureIcon src={feature.icon} alt={feature.title} />
          <SubTitle>{feature.title}</SubTitle>
          <SubDescription>{feature.description}</SubDescription>
        </SubFeatureCard>
        {!isLast && <Divider />}
      </ResponsiveContainer>
    );
  }
);

const ResponsiveContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const SubFeatureCard = styled.div`
  flex: 1;
  padding: 36px;
  flex-direction: column;
`;

const SubTitle = styled.p`
  font-size: 1.3em;
  color: #002671;
`;

const SubFeatureIcon = styled.img`
  width: 98px;
  height: 98px;
`;

const SubDescription = styled.p`
  font-size: 1rem;
  color: #405c94;

  @media (max-width: 1025px) {
    padding: 0px;
  }
`;

const Divider = styled.div`
  background: linear-gradient(
    90deg,
    #7e80ed 24%,
    #7d87ee 41%,
    #7a9bf1 66%,
    #76bcf6 96%,
    #76c0f7 98%
  );
  width: 1px;
  align-self: center;
  height: 80%;

  @media (max-width: 767px) {
    width: 90%;
    height: 1px;
    margin: 0;
  }
`;

export default memo(DetailComponent);
